

import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AppCommonService } from 'src/app/app.common.service';
import { Location } from "@angular/common";
import { Router, NavigationEnd } from "@angular/router";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiRootService } from 'src/app/apiroot.service';
import { ReportsService } from '../reports.service';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { timeout } from 'rxjs/operators';

@Component({
  selector: 'app-download-report',
  templateUrl: './download-report.component.html',
  styleUrls: ['./download-report.component.scss']
})
export class DownloadReportComponent implements OnInit {
  @ViewChild('noData', { static: true }) public noData: SwalComponent;  
  @ViewChild('errorbox', { static: true }) errorbox: SwalComponent;
  htmlContent: string;
  private history: string[] = [];
  isPdfLoading: boolean = false;
  pdfType: string;
  pdfTitleName: string;
  downloadPdfUrl: any;
  downloadLink: string | null = null;
  showViewReportButton: boolean = false;
  constructor(private route: ActivatedRoute, public service: ApiRootService, private _sanitizer: DomSanitizer, public commonService: AppCommonService, private location: Location, private rs: ReportsService, private router: Router, public dialogRef: MatDialogRef<DownloadReportComponent>,
    public http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    console.log("check-data", this.data);
    if (this.data && this.data.htmlContent) {
      this.htmlContent = this.transform(this.data.htmlContent);
      this.pdfTitleName = this.data.name;
      this.pdfType = this.data.pdfType;
      this.downloadPdfUrl = this.data.downloadPdfUrl;
    }
  }

  closePopup(){
    console.log("Test is succesfull")
  }

  downloadPDF(pdfTitleName: any) {
    // Check if the user is online or offline
    if (!navigator.onLine) {
      console.log("No internet connection. Please check your network.");
      this.errorbox.title = 'Network Error';
      this.errorbox.text = 'No internet connection detected. Please check your network.';
      this.errorbox.show();
      return;
    }
  
    console.log(this.pdfType, this.pdfTitleName + ' pdfType');
  
    var isPdfLoading = document.getElementById('isPdfLoading');
    if (isPdfLoading) isPdfLoading.style.display = 'inline-block';
  
    console.log("isPdf Flag ::", this.isPdfLoading);
    var node = document.getElementById("print-section");
    if (!node) {
      console.error("Error: Print section not found!");
      this.errorbox.title = 'Error';
      this.errorbox.text = 'Unable to find the print section.';
      this.errorbox.show();
      return;
    }
  
    const clonedNode = node.cloneNode(true) as HTMLElement;
    const addCommentButtons = clonedNode.querySelectorAll('.commentbuttonaTarget');
    addCommentButtons.forEach(button => button.remove());
    var htmlContent = clonedNode.innerHTML;
    console.log("Modified htmlContent :::", htmlContent);
  
    if (this.pdfType === 'log') {
      this.commonService.downloadPdfCommonFn(pdfTitleName, isPdfLoading);
    } else {
      console.log("Before response ::");
  
      let timeoutReached = false;
      
      // Set a timeout to prevent infinite loading
      const timeout = setTimeout(() => {
        timeoutReached = true;
        if (isPdfLoading) isPdfLoading.style.display = 'none';
        console.error("Server did not respond in time. Stopping PDF download.");
        this.errorbox.title = 'Server Timeout';
        this.errorbox.text = 'The request is taking too long. Please try again later.';
        this.errorbox.show();
      }, 600000); 
  
      this.convertHtmlToPdf(htmlContent).subscribe(
        (res: Blob) => {
          if (!timeoutReached) {
            clearTimeout(timeout); // Clear timeout if response is received
            console.log("response ::", res);
            const blob = new Blob([res], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            this.downloadPdf(res, this.pdfTitleName + '.pdf');
            window.URL.revokeObjectURL(url);
            if (isPdfLoading) isPdfLoading.style.display = 'none';
          }
        },
        (error) => {
          if (!timeoutReached) {
            clearTimeout(timeout); // Clear timeout if error occurs
            console.error('PDF generation failed:', error);
            this.errorbox.title = 'Error';
            this.errorbox.text = 'PDF generation failed. Please try again later.';
            this.errorbox.show();
            if (isPdfLoading) isPdfLoading.style.display = 'none';
          }
        }
      );
    }
  }


  downloadPdf(data: Blob, filename: string) {
    const url = window.URL.createObjectURL(data);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  }

  convertHtmlToPdf(htmlContent: string, options: any = {}): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = { html: htmlContent, ...options };

    // Convert body to JSON string to calculate size
    const bodyString = JSON.stringify(body);
    const payloadSizeInBytes = new TextEncoder().encode(bodyString).length;

    // Convert size to KB or MB for readability
    const payloadSizeInKB = (payloadSizeInBytes / 1024).toFixed(2);
    const payloadSizeInMB = (payloadSizeInBytes / (1024 * 1024)).toFixed(2);

    console.log("check-bodystring", bodyString);
    console.log(`Payload Size: ${payloadSizeInBytes} bytes (~${payloadSizeInKB} KB / ${payloadSizeInMB} MB)`);


    return this.http.post(this.downloadPdfUrl, body, { headers, responseType: 'blob' });
  }

  transform(v: any): any {
    return this._sanitizer.bypassSecurityTrustHtml(v);
  }

  back(): void {
    this.location.back();
  }

}
